export default "__VITE_ASSET__vTfDcPfI__"